import { render, staticRenderFns } from "./PagePrivacy.vue?vue&type=template&id=5ac0bb3e&scoped=true"
import script from "./PagePrivacy.vue?vue&type=script&lang=js"
export * from "./PagePrivacy.vue?vue&type=script&lang=js"
import style0 from "./PagePrivacy.vue?vue&type=style&index=0&id=5ac0bb3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac0bb3e",
  null
  
)

export default component.exports